module.exports = __webpack_public_path__ + "img/Support-skill-mana.142aa1fe.png";